






















































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import { TheMask } from "vue-the-mask";
import VueRecaptcha from "vue-recaptcha";
import LanguageControl from "_P/LanguageControl";
import { InsuranceCard, Widget } from "@/services/index.defs";
import { sendPostMessageEvent, EventName } from '@/utils/analyticMessages';

@Component({ components: { TheMask, VueRecaptcha } })
export default class LeftSideGosSign extends Vue {
    @Ref() readonly regionInput!: Vue;
    @Ref() readonly signInput!: Vue;
    log = "";
    @Watch("gosSign") moveFocus(newVal: string) {
        if (newVal.length > 5) {
            const input = this.regionInput.$el as HTMLInputElement;
            input.focus();
            // костыль для iphone
            let forceFocus = () => {
                if (input != document.activeElement) input.focus();
            };
            setTimeout(forceFocus, 230);
        }
    }

    statsSent = false;
    async created() {
        this.onCardLPChanged(this.card.car.licensePlate);
        this.$store.state.showRecentCalc = true;
    }

    gosSign = "";
    gosSignRegion = "";
    @Watch("gosSign")
    @Watch("gosSignRegion")
    gosSignChanged() {
        if (!this.statsSent) {
            this.statsSent = true;
        }
        this.gosSign = LanguageControl.EnToRus(this.gosSign).toUpperCase();
        this.card.car.licensePlate = this.gosSign + this.gosSignRegion;
    }
    @Watch("card.car.licensePlate")
    onCardLPChanged(val: string) {
        if (!!val && this.gosSign + this.gosSignRegion != val) {
            this.gosSign = val.substring(0, 6);
            this.gosSignRegion = val.substring(6);
        }
    }
    gosSignTokens = {
        "#": { pattern: /\d/ },
        R: {
            pattern: /[авекмнорстухАВЕКМНОРСТУХfFdDtTrRvVyYjJhHcCnNeE]/, // /[авекмнорстухАВЕКМНОРСТУХ]/,
            transform: (v: string) => v.toLocaleUpperCase()
        }
    };
    focusSign() {
        if (!this.gosSignRegion)
            (this.signInput.$el as HTMLInputElement).focus();
    }
    get kostylPlaceholderGos() {
        // PAM-1284
        let gosSign: string = JSON.parse(JSON.stringify(this.gosSign));
        if (!gosSign.length) return "А 000 АА";
        const insertSpace = (gosSign, index) =>
            gosSign.slice(0, index) +
            " " +
            gosSign.slice(index, gosSign.length);
        if (gosSign.length >= 2) {
            gosSign = insertSpace(gosSign, 1);
        }
        if (gosSign.length >= 5) {
            gosSign = insertSpace(gosSign, 5);
        }
        const value = gosSign;
        const charsLeft = "А 000 AA".slice(gosSign.length, 8);
        return value + charsLeft; // should be monospace font
    }

    get kostylPlaceholderRegion() {
        if (!this.gosSignRegion.length) return "000";
        else return this.gosSignRegion.padEnd(3, "0");
    }
    get widget(): Widget {
        return this.$store.direct.state.widget;
    }
    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }

    get isValid(): boolean {
        if (
            this.gosSign == "" ||
            this.gosSign.length < 6 ||
            this.gosSignRegion == "" ||
            this.gosSignRegion.length < 2
        ) {
            return false;
        }

        return true;
    }
    onCaptchaExpired() {
        (this.$refs.recaptcha as any).reset();
    }
    nextClickFail: boolean = false;
    async nextStep(token: any) {
        if (!this.isValid) {
            this.nextClickFail = true;
            return;
        }
        sendPostMessageEvent(EventName.GosSign);
        const res = await this.$store.direct.dispatch.info.getAutoFullInfo({
            licensePlate: this.card.car.licensePlate,
            token: token
        });
        if (!res.success) {
            this.widget.gosSignOn = false;
            if (res.error == "ratelimit") {
                this.$emit("ratelimit");
            }
        } else {
            if (
                this.card.car.markId && // if no mark response from autocode, but it exists in recent calc
                (!res.data.report.markId || res.data.report.markId === "0") // blame backend for === "0"
            )
                await this.$store.direct.dispatch.dicti.getMapModels(
                    this.card.car.markId
                );
            this.$root.scrollUp();
            this.$emit("next");
            this.$store.state.showRecentCalc = false;
        }
    }
}
